<template>
  <div>
    <div class="d-flex align-items-start">
      <validation-provider
        class="w-100"
        :ref="inputId"
        :name="inputName"
        :rules="inputValidationRules"
        v-slot="validationContext">
        <b-form-group
          class="form-input-wrapper"
          :label="customPlaceholder ? customPlaceholder : inputName"
          :label-for="inputId"
          :label-class="(!!model) ? 'form-label font-weight-bold filled-field-datetimepicker' : 'form-label font-weight-bold empty-field'"
          :invalid-feedback="validationContext.errors[0]"
        >
          <b-form-input
            v-if="!visible"
            v-mask="'##.##.####'"
            :disabled="disabled"
            :id="inputId"
            :class="{ 'form-input': true, 'filled-field': (!!model), 'required-field': (!(!!model) && required), inputId: true }"
            v-model="model"
            @blur="placeholder = (customPlaceholder ? customPlaceholder : inputName)"
            @click="changePlaceholder"
            :placeholder="placeholder"
            @change="updateIdbData"
            @input="checkFormInputData"
            :state="getValidationState(validationContext)"
            trim
          ></b-form-input>
          <ctk-date-time-picker
            v-if="visible"
            :disabled="disabled"
            v-model="model"
            :class="{ 'form-input': true, 'filled-field': (!!model) }"
            :id="inputId"
            :label="customPlaceholder ? customPlaceholder : inputName"
            button-now-translation="Сегодня"
            :color="color"
            locale="ru"
            :custom-shortcuts="customShortcuts"
            onlyDate
            noLabel
            format="DD.MM.YYYY"
            formatted="DD.MM.YYYY"
            @is-hidden="closeDateTimePicker"
            @input="updateIdbData"
            :state="getValidationState(validationContext)"
          >
          </ctk-date-time-picker>
          <span v-if="visible" class="custom-invalid-feedback">{{ validationContext.errors[0] }}</span>
        </b-form-group>
      </validation-provider>
      <span>
        <b-button
          @click="toggleDateTimePicker"
          :disabled="disabled"
          class="ml-2"
          size="sm"
          variant="outline-secondary"
          squared>
          <font-awesome-icon icon="fa-solid fa-calendar" />
        </b-button>
      </span>
      <span v-if="create" title="Сохранить в справочник" v-b-tooltip.hover>
        <b-button
          @click="addToCatalog"
          class="ml-2"
          size="sm"
          variant="outline-success"
          :disabled="disabled"
          squared>
          <font-awesome-icon icon="fa-solid fa-floppy-disk" />
        </b-button>
      </span>
    </div>
  </div>
</template>

<script>
  import CtkDateTimePicker from 'vue-ctk-date-time-picker'
  import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css'
  import { simulateEventMixin } from './mixins/simulateEventMixin'
  import moment from 'moment'
  export default {
    name: "CustomDatepicker",
    mixins: [simulateEventMixin],
    props: {
      inputId: {
        default: null,
        type: String
      },
      inputName: {
        default: null,
        type: String
      },
      customPlaceholder: {
        default: null,
        type: String
      },
      index: {
        default: null,
        type: Number
      },
      parent: {
        default: null,
        type: String
      },
      inputValidationRules: {
        default: null,
        type: Object
      },
      createFields: {
        default: null,
        type: Array
      },
      postData: {
        type: Function
      },
      disabled: {
        default: false,
        type: Boolean
      },
      required: {
        default: false,
        type: Boolean
      },
      create: {
        default: false,
        type: Boolean
      },
      color: {
        default: '#40b539',
        type: String
      }
    },
    components: {
      CtkDateTimePicker
    },
    data () {
      return {
        model: null,
        targetInput: null,
        visible: false,
        placeholder: null,
        customShortcuts: [
          { key: 'thisWeek', label: 'Эта неделя', value: 'isoWeek' },
          { key: 'thisMonth', label: 'Этот месяц', value: 'month' },
          { key: 'thisYear', label: 'Этот год', value: 'year' }
        ],
      }
    },
    watch: {
      model (val) {
        if (/^\d{4}-\d{2}-\d{2}T(.*?)$/.test(val)) {
          let date = val.split('T')
          date = date[0].split('-')
          date = date[2] + '.' + date[1] + '.' + date[0]
          this.model = date
        }
      },
    },
    mounted () {
      this.placeholder = this.customPlaceholder ? this.customPlaceholder : this.inputName
    },
    methods: {
      toggleDateTimePicker () {
        this.visible = !this.visible
        setTimeout(() => {
          if (this.visible === true) {
            this.simulate(document.getElementById(this.inputId + '-input'), "click")
          }
        }, 100)
      },
      closeDateTimePicker () {
        this.visible = false
        this.checkFormInputData()
      },
      checkFormInputData () {
        this.$nextTick(() => {
          if (this.model === '') {
            this.model = null
            this.$emit('updateIdbData')
          }
        })
      },
      getValidationState ({ dirty, validated, valid = null }) {
        return dirty || validated ? valid : null
      },
      changePlaceholder () {
        this.placeholder = '00.00.0000'
      },
      updateIdbData () {
        console.log('updateIdbData')
        this.$nextTick(() => {
          window.dispatchEvent(new KeyboardEvent('keydown', {
            key: "escape",
            keyCode: 27,
            shiftKey: false,
            ctrlKey: false,
            metaKey: false
          }))
          if (this.model) {
            let date = this.model.split('.')
            date = date[2] + '-' + date[1] + '-' + date[0]
            date = moment(date).format('YYYY-MM-DDTHH:mm:ss.sssZ')
            this.$emit('setForm', { fieldName: this.inputId, item: date, index: this.index, parent: this.parent })
          }
        })
      },
      addToCatalog () {
        const hasEmptyFields = this.createFields.filter((item) => {
          return (item.value === null) || (item.value === '')
        })
        if (hasEmptyFields.length > 0) {
          this.$bvToast.toast('Заполните поля, необходимые для сохранения в справочник!', {
            title: 'Не заполнены обязательные поля',
            toaster: 'b-toaster-bottom-right',
            solid: true,
            appendToast: true
          })
        } else {
          this.$bvModal.msgBoxConfirm('Вы действительно хотите сохранить данные в справочник?', {
            okTitle: 'Да',
            cancelTitle: 'Нет',
            size: 'sm',
            buttonSize: 'sm',
            hideHeaderClose: true,
            centered: true
          }).then(value => {
            if (value === true) {
              let refsData = {}
              this.createFields.map((item) => {
                refsData[item.key] = item.value
              })
              this.postData({ data: refsData }).then(
                () => {
                  this.$bvToast.toast('Справочник сохранен!', {
                    title: 'Данные успешно добавлены',
                    toaster: 'b-toaster-bottom-right',
                    solid: true,
                    appendToast: true
                  })
                }
              )
            }
          }).catch(err => {
            console.log(err)
          })
        }
      }
    }
  }
</script>

<style scoped>

</style>
